import * as React from 'react';
import { CmicContext } from '../../context/CmicContext';
import { styled, alpha } from '@mui/material/styles';
import { FiLogOut } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { THEME_ID, baseFontFamilyStyle } from '../../shared/styles';
import { COLORS } from '../../utility/tasks/colors';
import { Stack } from '@fluentui/react';
import { handleTHEMECLR } from '../../components/BorderImage';
import { isBGClrDark } from '../../utility/UtilityFunctions';
import { getApiInfoService, handleUserlogout } from '../../utility/fetchData';

export default function SettingsMenu({ HeaderAttchDocumentStyle, isLoading, setIsLoading }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const { currentOfficeTheme, userInfo, setUserInfo, setShowToast } = React.useContext(CmicContext);
	const [apiInfo, setApiInfo] = React.useState({ sysUpgradeCode: '', webServicesVersion: '' });
	const appVersion = React.useRef('');

	const open = Boolean(anchorEl);
	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	React.useEffect(async () => {
		setApiInfo(await getApiInfoService(userInfo));
		try {
			const versionData = require('./../../../../version.json');
			appVersion.current = versionData.version || '1.0.0.0';
		} catch (err) {
			console.log('Error reading version.json:', err);
			appVersion.current = '1.0.0.0';
		}
	}, []);

	const navigate = useHistory();

	const StyledMenu = styled(props => (
		<Menu
			elevation={0}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			{...props}
		/>
	))(({ theme }) => ({
		'& .MuiPaper-root': {
			marginTop: theme.spacing(1),
			minWidth: 180,
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
			boxShadow: `${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 5px 0.1px`,
			'& .MuiMenu-list': {
				padding: '4px 0',
			},
			'& .MuiMenuItem-root:hover': {
				backgroundColor:
					currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
						? '#383838'
						: '#e6f2fa',
			},
			'& .MuiMenuItem-root': {
				'& .MuiSvgIcon-root': {
					fontSize: 18,
					color: currentOfficeTheme.bodyForegroundColor,
					marginRight: theme.spacing(1.5),
				},
				'&:active': {
					backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
				},
			},
		},
	}));

	const textStyle = {
		color: currentOfficeTheme.bodyForegroundColor,
		fontFamily: baseFontFamilyStyle,
		margin: '0.2rem',
		fontWeight: '400',
		fontSize: '13px',
		marginRight: '15px',
		cursor: 'pointer',
	};

	const getDisplayInitials = () => {
		if (userInfo?.info?.contactCode?.length === 2) {
			return userInfo.info.contactCode;
		}
		const initials = `${userInfo?.info?.firstName?.charAt(0) || ''}${userInfo?.info?.lastName?.charAt(0) || ''}`;
		return initials || '-';
	};

	const textLabelStyle = {
		color: 'rgba(164,164,164,255)',
		fontFamily: baseFontFamilyStyle,
		fontWeight: '400',
		fontSize: '13px',
		marginRight: '15px',
		cursor: 'pointer',
	};

	return (
		<Stack
			className={handleTHEMECLR(currentOfficeTheme)}
			onClick={open ? handleClose : handleClick}
			style={{
				...{
					display: 'flex',
					padding: '4px 10px',
					alignItems: 'center',
					justifyContent: 'center',
					cursor: 'pointer',
					marginLeft: '5px',
					border:
						currentOfficeTheme.themeId === THEME_ID.BLACK
							? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
							: '1px solid rgba(174, 180, 189, 1)',
				},
				...HeaderAttchDocumentStyle,
			}}
		>
			<h1
				id="demo-customized-button"
				aria-controls={open ? 'demo-customized-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				variant="contained"
				style={{
					fontSize: '20px',
					color: isBGClrDark() ? COLORS.OUTLOOK_LIGHT_BLUE : COLORS.OUTLOOK_DARK_BLUE,
					margin: '0 5px',
				}}
			>
				&#8942;
			</h1>
			<StyledMenu
				id="demo-customized-menu"
				MenuListProps={{
					'aria-labelledby': 'demo-customized-button',
				}}
				style={{ cursor: 'pointer' }}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				{' '}
				<MenuItem disableRipple style={{ cursor: 'pointer' }}>
					<div
						style={{
							height: '30px',
							width: '30px',
							background: 'grey',
							borderRadius: '50%',
							textAlign: 'center',
							marginRight: '5px',
						}}
					>
						<div style={{ marginTop: '2px', color: currentOfficeTheme.bodyBackgroundColor }}>
							{getDisplayInitials()}
						</div>
					</div>
					<label style={textStyle}>{`${userInfo?.info?.firstName} ${userInfo?.info?.lastName}`}</label>
				</MenuItem>
				<MenuItem
					disableRipple
					style={{ cursor: 'pointer' }}
					onClick={async () => {
						const result = await handleUserlogout(
							userInfo,
							setUserInfo,
							navigate,
							setIsLoading,
							setShowToast,
						);
					}}
				>
					<FiLogOut style={{ color: '#aeb4bd', height: '30px', width: '30px', marginRight: '3px' }} />
					<label style={textStyle}>Logout</label>
				</MenuItem>
				<MenuItem
					disableRipple
					style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'start' }}
				>
					<div style={textLabelStyle} aria-disabled>
						App Version
					</div>
					<div style={textStyle}>{appVersion.current ? appVersion.current : '-'}</div>
				</MenuItem>
				<MenuItem
					disableRipple
					style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'start' }}
				>
					<div style={textLabelStyle} aria-disabled>
						Webservice Version
					</div>
					<div style={textStyle}>{apiInfo?.webServicesVersion ? apiInfo?.webServicesVersion : '-'}</div>
				</MenuItem>
				<MenuItem
					disableRipple
					style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'start' }}
				>
					<div style={textLabelStyle} aria-disabled>
						System Level
					</div>
					<div style={textStyle}>{apiInfo?.sysUpgradeCode ? apiInfo?.sysUpgradeCode : '-'}</div>
				</MenuItem>
			</StyledMenu>
		</Stack>
	);
}
